import { action, observable } from 'mobx'

export class AdjustmentListStore {
  @observable currentAdjustment = null
  @observable currentTableIndex = -1
  @observable adjustmentList = null
  @observable adjustedTransactionLines = null
  @observable adjustmentId = null
  @observable journalId = null

  @action setCurrentAdjustment = (rec) => {
    this.currentAdjustment = rec
  }

  @action setAdjustmentList = (list) => {
    this.adjustmentList = list
  }

  @action setAdjustedTransactionLines = (lines) => {
    this.adjustedTransactionLines = lines
  }

  @action setAdjustmentId = (id) => {
    this.adjustmentId = id
  }

  @action setJournalId = (id) => {
    this.journalId = id
  }
}
